import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _UploadCloudIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M1.01328 6.84323C2.73489 3.53932 6.31417 1.63767 10.0157 2.0603C13.4557 2.45308 16.3404 4.77793 17.4793 7.99975H18C20.7422 8.00156 23.1349 9.86229 23.8113 12.5198C24.4877 15.1773 23.2764 17.9552 20.8687 19.2677C20.3838 19.5321 19.7764 19.3533 19.512 18.8684C19.2477 18.3835 19.4265 17.7761 19.9114 17.5117C21.5165 16.6367 22.3241 14.7848 21.8731 13.0131C21.4222 11.2414 19.8275 10.001 17.9994 9.99975H16.74C16.2841 9.99975 15.886 9.69142 15.7719 9.25005C15.0466 6.44464 12.6677 4.37611 9.78879 4.04739C6.90984 3.71868 4.12596 5.19774 2.78693 7.76745C1.4479 10.3372 1.83056 13.4662 3.74936 15.6376C4.11508 16.0514 4.07607 16.6834 3.66222 17.0491C3.24838 17.4148 2.61641 17.3758 2.2507 16.9619C-0.216341 14.1703 -0.708325 10.1471 1.01328 6.84323Z"
        fill={iconColor}
      />
      <Path
        d="M12.7071 11.2926C12.3166 10.9021 11.6834 10.9021 11.2929 11.2926L7.29289 15.2926C6.90237 15.6832 6.90237 16.3163 7.29289 16.7069C7.68342 17.0974 8.31658 17.0974 8.70711 16.7069L11 14.414V20.9998C11 21.552 11.4477 21.9998 12 21.9998C12.5523 21.9998 13 21.552 13 20.9998V14.414L15.2929 16.7069C15.6834 17.0974 16.3166 17.0974 16.7071 16.7069C17.0976 16.3163 17.0976 15.6832 16.7071 15.2926L12.7071 11.2926Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const UploadCloudIcon = assignWithoutSideEffects(_UploadCloudIcon, {
  componentId: 'UploadCloudIcon',
});

export default UploadCloudIcon;
